import { FCX } from "@datassential/platform-ui-lib";
import { AiOutlineInfoCircle } from "react-icons/ai";
import './HeaderInfo.scss';

interface HeaderInfoProps {
    text: string;
    highlightWord?: string;
    highlightColor?: string;
    infoTooltipId?: string;
}

const HeaderInfo: FCX<HeaderInfoProps> = ({
  text,
  highlightWord = "",
  highlightColor = '#00E1AF',
  infoTooltipId,
}) => {
    const parts = highlightWord ? text.split(new RegExp(`(${highlightWord})`, 'i')) : [text];

    return (
        <div className="HeaderInfo">
            <span className="HeaderInfo__text">
                {parts.map((part, index) =>
                    highlightWord && part.toLowerCase() === highlightWord.toLowerCase() ? (
                        <span
                            key={index}
                            className="HeaderInfo__highlight"
                            style={{ color: highlightColor }}
                        >
                            {part}
                        </span>
                    ) : (
                        <span key={index}>{part}</span>
                    )
                )}
            </span>
            {infoTooltipId && (
                <AiOutlineInfoCircle
                    className="HeaderInfo__info-icon"
                    data-tooltip-id={infoTooltipId}
                />
            )}
        </div>
    );
};

export default HeaderInfo;
